import { CheckCircle, XCircle } from "lucide-react";
import React from "react";

const Toast: React.FC<{
  type: "success" | "error";
  message: string;
  onClose: () => void;
}> = ({ type, message, onClose }) => {
  React.useEffect(() => {
    const t = setTimeout(onClose, 3000);
    return () => clearTimeout(t);
  }, [onClose]);

  const bg =
    type === "success"
      ? "bg-green-50 border-green-300 text-green-800"
      : "bg-red-50 border-red-300 text-red-800";

  return (
    <div
      className={`fixed bottom-4 right-4 z-50 flex items-center gap-2 p-4 rounded-lg border-2 ${bg} shadow-lg animate-in fade-in slide-in-from-bottom duration-300`}
    >
      {type === "success" ? <CheckCircle size={20} /> : <XCircle size={20} />}
      <span className="text-sm font-medium">{message}</span>
      <button
        onClick={onClose}
        className="ml-2 text-current opacity-70 hover:opacity-100"
        aria-label="Close toast"
      >
        <XCircle size={16} />
      </button>
    </div>
  );
};

export default Toast;
